import React from "react";

const sahil_tejwani = () => {
  return (
    <div>
      <h1>Sahil Tejwani</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>CSI Internship Diaries 2025</strong>
        <br />
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The shortlisting was based on maintaining a minimum CGPA of 7.0 and
        having no active backlogs.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The recruitment process started with an online Pre-Placement Talk (PPT)
        on 18th August, where the company representatives provided an overview
        of the organization, internship role, and selection procedure. On the
        same day, an online assessment was conducted. Shortlisted candidates
        were then invited for the next stage, which took place on 26th August.
        Both the Technical and HR interviews were conducted. The final results
        were announced on 26th August itself, marking the completion of the
        entire interview process.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
      </p>

      <p>
        The aptitude round was conducted in two parts. The first part focused on
        logical reasoning, listening skills, and English proficiency, which
        included questions on synonyms, antonyms, paragraph reading with
        comprehension-based answers, and arranging sequences in chronological
        order. After completing this section, a second link was shared via email
        with almost all students. This second part consisted of three coding
        questions based on Data Structures and Algorithms, ranging from easy to
        medium difficulty level.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of 16 students were shortlisted for the internship after
        successfully clearing the aptitude round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced around four days before the interviews.
        However, since there was considerable time between the online aptitude
        test and the interviews, I began preparing immediately after the
        aptitude round. During this period, I focused on strengthening the core
        subjects mentioned in my resume, such as Operating Systems, DBMS, and
        OOPs concepts. I also revisited my MERN-based projects and practiced
        additional DSA questions to enhance my problem-solving skills and
        technical readiness for the interviews.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>
        The interview process consisted of two rounds: a Technical round
        followed by an HR round. After the online aptitude round, 16 students
        were shortlisted for the Technical round, where candidates were
        evaluated on their domain knowledge, problem-solving skills, and
        understanding of subjects like OS, DBMS, OOPs, and projects listed in
        their resumes. Out of these, 5 students were shortlisted for the HR
        round, which assessed communication skills, cultural fit, and overall
        personality. All 5 students who cleared the HR round were finally
        selected for the internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        During the interviews, the focus was mainly on technical subjects and
        problem-solving skills. In the Technical round, the interviewers
        emphasized Data Structures and Algorithms (DSA), Operating Systems (OS),
        Database Management Systems (DBMS), Object-Oriented Programming (OOPs).
        The HR round concentrated on behavioral aspects, including communication
        skills, teamwork, adaptability, and overall personality to assess
        cultural fit within the company.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA - Strivers A2Z Sheet
        <br />
        DBMS - Notes by CodeHelp by LoveBabbar
        <br />
        OS - Notes by CodeHelp by LoveBabbar{" "}
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
      </p>

      <p>
        Be consistent in practicing coding problems regularly. Focus on
        understanding the logic behind each problem, strengthen your grasp on
        Data Structures and Algorithms, and try to solve problems of varying
        difficulty levels to build confidence and speed.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        [enter details here]
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?
      </p>

      <p>
        For those preparing for HSBC, it is important to know that the interview
        process is systematic and conducted fairly. The interviewers place a
        strong emphasis on your problem-solving approach rather than just the
        final answer. In the Technical round, topics like DBMS and Operating
        Systems were primarily focused on, so a clear understanding of these
        subjects and the ability to explain your thought process effectively can
        greatly help in succeeding.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Stay relaxed and calm throughout the process, trust in your abilities,
        and approach each stage with confidence. Most importantly, enjoy the
        experience and learn from it rather than stressing over the outcome.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:tejwanisahil73@gmail.com">tejwanisahil73@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default sahil_tejwani;
